import { render } from "./SpotsUpdate.vue?vue&type=template&id=ee994e1a&scoped=true"
import script from "./SpotsUpdate.vue?vue&type=script&lang=js"
export * from "./SpotsUpdate.vue?vue&type=script&lang=js"

import "./SpotsUpdate.vue?vue&type=style&index=0&id=ee994e1a&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee994e1a"]])

export default __exports__